import React from 'react';
import PropTypes from 'prop-types';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import {alpha, makeStyles} from '@material-ui/core/styles';
import clsx from 'clsx';

const ALTURA_EDITOR = 200;

// Fora do componente: o Quill só lê os módulos ao montar e avisa quando o objeto muda a cada render.
const MODULOS = {
    toolbar: [
        [{header: [1, 2, 3, false]}],
        ['bold', 'italic', 'underline', 'strike'],
        [{color: []}, {background: []}],
        [{list: 'ordered'}, {list: 'bullet'}],
        ['link'],
        ['clean']
    ]
};

const useStyles = makeStyles(theme => ({
    root: {
        width: '100%',
        '& .ql-toolbar.ql-snow': {
            borderTopLeftRadius: theme.shape.borderRadius,
            borderTopRightRadius: theme.shape.borderRadius,
            borderColor: alpha(theme.palette.common.black, 0.23)
        },
        '& .ql-container.ql-snow': {
            borderBottomLeftRadius: theme.shape.borderRadius,
            borderBottomRightRadius: theme.shape.borderRadius,
            borderColor: alpha(theme.palette.common.black, 0.23),
            fontFamily: theme.typography.fontFamily,
            fontSize: theme.typography.body1.fontSize
        },
        '& .ql-editor': {
            minHeight: ALTURA_EDITOR,
            maxHeight: ALTURA_EDITOR * 2,
            overflowY: 'auto'
        }
    },
    erro: {
        '& .ql-toolbar.ql-snow, & .ql-container.ql-snow': {
            borderColor: theme.palette.error.main
        }
    }
}));

/*
 * Editor de texto rico (Quill, tema "snow") controlado, para usar com o
 * Controller do react-hook-form. O Quill dispara onChange ao montar e ao
 * normalizar o HTML (por exemplo '' vira '<p><br></p>'); só as alterações
 * feitas pelo usuário (source === 'user') chegam ao formulário, para não
 * marcá-lo como alterado à toa.
 */
export default function EditorTexto({value, onChange, onBlur, error, placeholder}) {
    const classes = useStyles();

    const handleChange = (html, delta, source) => {
        if (source === 'user' && onChange) {
            onChange(html);
        }
    };

    return (
        <div className={clsx(classes.root, error && classes.erro)}>
            <ReactQuill
                theme='snow'
                value={value || ''}
                modules={MODULOS}
                placeholder={placeholder}
                onChange={handleChange}
                onBlur={() => onBlur && onBlur()}/>
        </div>
    );
}

EditorTexto.propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
    error: PropTypes.bool,
    placeholder: PropTypes.string
};
